import { render, staticRenderFns } from "./rankMoreVideo.vue?vue&type=template&id=182d4a28&scoped=true&"
import script from "./rankMoreVideo.vue?vue&type=script&lang=js&"
export * from "./rankMoreVideo.vue?vue&type=script&lang=js&"
import style0 from "./rankMoreVideo.vue?vue&type=style&index=0&id=182d4a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182d4a28",
  null
  
)

export default component.exports